import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { useEffect, useState } from "react";
import DevToolsWarning from "./components/devtool/DevToolsWarning.tsx";
import DevToolsDetector from "./utils/devToolsDetector.ts";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./App.css";
import MultiLangRouter from "./routes/MultiLangRouter.tsx";
import { toggleIsMobile } from "./store/slices/IdSlice.ts";
import { useDispatch } from "react-redux";

function App() {
  const dispatch = useDispatch();
  const [devToolsOpen, setDevToolsOpen] = useState(false);
  const handleResize = () => {
    const che = window.innerWidth < 768
    dispatch(toggleIsMobile(che));
  };
  useEffect(() => {
    handleResize();
    const Development_Tool = import.meta.env.VITE_Development_Tool || "0";

    if (Development_Tool === "0") return;

    const devToolsDetector = new DevToolsDetector({
      onDevToolsOpen: () => {
        setDevToolsOpen(true);
      },
      onDevToolsClose: () => {
      },
      checkInterval: 1000, // Check every second
    });
    devToolsDetector.start();
    return () => {
      devToolsDetector.stop();
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  if (devToolsOpen) {
    return (
      <>
        <DevToolsWarning isVisible={devToolsOpen} onRefresh={handleRefresh} />
      </>
    );
  }

  const router = createBrowserRouter([
    ...MultiLangRouter
  ]);

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;

